import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getWebPushPublicKey = async () =>
  (await axios.get(`${API_URL}/notifications/web-push/public-key`, withAuth())).data;

export const listMyWebPushSubscriptions = async () =>
  (await axios.get(`${API_URL}/notifications/web-push/me/subscriptions`, withAuth())).data;

export const saveMyWebPushSubscription = async (subscription) =>
  (await axios.post(`${API_URL}/notifications/web-push/me/subscriptions`, { subscription }, withAuth())).data;

export const sendTestWebPushNotification = async () =>
  (await axios.post(`${API_URL}/notifications/web-push/me/test`, {}, withAuth())).data;

export const deleteMyWebPushSubscription = async (id) =>
  (await axios.delete(`${API_URL}/notifications/web-push/me/subscriptions/${id}`, withAuth())).data;
